import React from 'react';
import { reportError } from '../lib/error-reporter';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Stale chunk after deploy: browser cached old index.html referencing deleted JS files.
    // Cloudflare Pages SPA fallback returns index.html (text/html) instead → MIME error.
    // Auto-reload once to fetch fresh index.html with correct chunk references.
    const isStaleChunk = error.message?.includes('MIME type')
      || error.message?.includes("Failed to fetch dynamically imported module")
      || error.message?.includes("Importing a module script failed");
    if (isStaleChunk && !sessionStorage.getItem('ev_chunk_reload')) {
      sessionStorage.setItem('ev_chunk_reload', '1');
      window.location.reload();
      return;
    }
    sessionStorage.removeItem('ev_chunk_reload');

    console.error('[ErrorBoundary]', error, errorInfo);
    reportError(error.message, {
      level: 'fatal',
      stack: error.stack,
      metadata: {
        source: 'ErrorBoundary',
        componentStack: errorInfo.componentStack?.slice(0, 2000),
      },
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback({ error: this.state.error, reset: this.handleReset });
      }
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '2rem',
          fontFamily: "'Source Sans 3', sans-serif", color: '#333',
        }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Something went wrong</h2>
          <p style={{ color: '#666', marginBottom: '1.5rem', maxWidth: 480, textAlign: 'center' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: '0.5rem 1.25rem', borderRadius: 6, border: '1px solid #ccc',
                background: '#fff', cursor: 'pointer', fontSize: '0.9rem',
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                padding: '0.5rem 1.25rem', borderRadius: 6, border: 'none',
                background: '#2D5A4A', color: '#fff', cursor: 'pointer', fontSize: '0.9rem',
              }}
            >
              Back to Library
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
